import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import context from '../context/recipesContext';
import foodsDetailsAPI from '../services/foodsDetailsAPI';
import whiteHeartIcon from '../images/whiteHeartIcon.svg';
import blackHeartIcon from '../images/blackHeartIcon.svg';
import ShareButton from './ShareButton';
import '../pages/css/FoodDetails.css';

function ListDetailsFoods({ id, pathname }) {
  const [meals, setMeals] = useState({});
  const [checkbox, setCheckbox] = useState(false);

  const {
    ingredients,
    arrayIngredients,
    changeFavoriteButton,
    favorite,
    setFavorite,
    favoriteRecipes,
    checked,
    setChecked,
  } = useContext(context);

  const {
    strMealThumb,
    strMeal,
    strCategory,
    strInstructions,
    strYoutube,
    strArea,
  } = meals;

  const favoriteMeals = {
    id,
    type: 'food',
    nationality: strArea,
    category: strCategory,
    alcoholicOrNot: '',
    name: strMeal,
    image: strMealThumb,
  };

  const checkboxIsVisible = () => {
    if (pathname.includes('/in-progress')) {
      setCheckbox(true);
    } else { setCheckbox(false); }
  };

  const favoriteRecipeMeals = (e) => {
    e.preventDefault();
    if (favorite === false) {
      localStorage.setItem(
        'favoriteRecipes', JSON.stringify([...favoriteRecipes, favoriteMeals]),
      );
    } else {
      const removeFavoriteRecipe = favoriteRecipes.filter((recipe) => recipe.id !== id);
      localStorage.setItem(
        'favoriteRecipes', JSON.stringify(removeFavoriteRecipe),
      );
    }
    setFavorite(!favorite);
  };

  const checkedIngredient = ({ target }) => {
    const { name } = target;
    const filterChecked = checked.filter((ingredient) => ingredient !== name);
    if (target.checked) {
      setChecked((prevState) => [...prevState, name]);
    } else {
      setChecked(filterChecked);
    }
  };

  useEffect(() => {
    const fetchMeals = async () => {
      const getMeals = await foodsDetailsAPI(id);
      setMeals(getMeals);
      arrayIngredients(getMeals);
    };
    fetchMeals();
    changeFavoriteButton(id);
    checkboxIsVisible();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="details-content">
      <h1 data-testid="recipe-title">
        { strMeal }
      </h1>
      <img
        className="recipe-image"
        data-testid="recipe-photo"
        src={ strMealThumb }
        alt={ strMeal }
        width="200px"
      />
      <div className="d-buttons">
        <button
          type="button"
          onClick={ favoriteRecipeMeals }
          className="b-favorite"
        >
          <img
            data-testid="favorite-btn"
            src={ favorite ? blackHeartIcon : whiteHeartIcon }
            alt="Favorite"
          />
        </button>
        <ShareButton id={ id } />
      </div>
      <h3 data-testid="recipe-category" className="t-info">
        {strCategory}
      </h3>
      <div className="recipe-category">
        <h2>Ingredients</h2>
        <div className="check-list">
          { checkbox
            ? ingredients.map((ingredient, index) => (
              <div key={ index }>
                <label
                  htmlFor={ index }
                  data-testid={ `${index}-ingredient-step` }
                  className={ checked.includes(ingredient) ? 'lineThought' : undefined }
                >
                  <input
                    onChange={ checkedIngredient }
                    type="checkbox"
                    id={ index }
                    className="i-item"
                    name={ ingredient }
                    defaultChecked={ checked.includes(ingredient) }
                  />
                  {ingredient}
                </label>
              </div>
            ))
            : ingredients.map((ingredient, index) => (
              <p
                data-testid={ `${index}-ingredient-name-and-measure` }
                key={ index }
              >
                {ingredient}
              </p>
            ))}
        </div>
      </div>
      <div className="instructions">
        <h2>Instructions</h2>
        <p data-testid="instructions">
          { strInstructions }
        </p>
      </div>
      <div className="video">
        <h2>Vídeo</h2>
        <iframe
          data-testid="video"
          width="300"
          height="200"
          src={ strYoutube }
          title={ strMeal }
          frameBorder="0"
          allow="accelerometer;
          autoplay;
          clipboard-write;
          encrypted-media;
          gyroscope;
          picture-in-picture"
        />
      </div>
    </div>
  );
}

ListDetailsFoods.propTypes = {
  id: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default ListDetailsFoods;
